import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Icon = styled.img`
	height: 35px;

	@media (max-width: 1200px) {
		height: 29px;
	}

	@media (max-width: 992px) {
		height: 26px;
	}

	@media (max-width: 768px) {
		height: 23px;
	}

	@media (max-width: 600px) {
		height: 21px;
	}
`;

export const Title = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;

	padding-top: 15px;

	font-weight: 600;
	font-size: 16px;
	line-height: 20px;
	color: ${tokens.primary.tertiary};
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding-top: 25px;

	padding-right: 20px;

	button:nth-child(1n) {
		margin-right: 20px;
	}
`;

export const ContentContainer = styled.div`
	display: flex;
	width: 100%;

	gap: 4vw;

	padding: 30px 30px 0 30px;

	height: 690px;

	@media (max-height: 900px) {
		height: 570px;
		overflow: scroll;
	}

	@media (max-height: 800px) {
		height: 530px;
		overflow: scroll;
	}

	@media (max-height: 700px) {
		height: 430px;
		overflow: scroll;
	}
`;

export const LeftContent = styled.div`
	display: flex;
	flex-direction: column;

	width: 52%;

	gap: 20px;
`;

export const RightContent = styled.div`
	display: flex;
	flex-direction: column;

	width: 48%;

	gap: 20px;
`;

export const UploadContainer = styled.div`
	display: flex;
	label {
		height: 40px;
	}
`;

export const SuperscriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: end;

	margin-top: 280px;
`;

export const Superscription = styled.div<{ color: string }>`
	width: 100%;
	font-size: 14px;
	font-weight: 500;
	color: #64778f;
	margin-bottom: 15px;

	&:before {
		content: '';
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 5px;
		display: inline-block;
		background-color: ${({ color }) => color};
		vertical-align: middle;
	}
`;

export const RightButtons = styled.div`
	display: flex;
`;

export const LeftButtons = styled.div`
	display: flex;
	padding-left: 30px;
`;
